module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/pepsi-dig-in-day-2024-0f1f6e7298bd495b57830d1a87872438.png";